
const drawerWidth = '19vw';

export const dashboardStyles = theme => ({
  vertCenter:{
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'column',
    cursor: 'pointer'
  },
  previewContainer: {
    display: 'flex',
    flexDirection: 'column',
    position: 'absolute',
    top: '0%',
    right: '0%',
    height: '100%',
    width: '29%',
    backgroundColor: 'rgba(34,40,55,0.85)',
    paddingTop: '6vh',
    overflowX: 'hidden'
  },
  profilePic: {
    width: '100%',
    height: '100%'
  },
  profile: {
    width: '49px',
    height: '49px',
    borderRadius: '50%',
    cursor: 'pointer',
    position: 'relative',
    overflow: 'hidden',
    marginLeft: '1vw',
  },
  listItemText: {
    fontSize: '15px'
  },
  pagination: {
    display: 'flex'
  },
  checkbox: {
    '&$checked': {
      color: 'yellow',
    },
    borderColor: 'rgba(149,168,210, 0.12)',
    color: `${theme.palette.battleShipGray} !important`,

  },
  snackbar: {
    backgroundColor: theme.palette.dark,
    border: '1px solid',
    borderColor: theme.palette.cloudyBlue,
    textAlign: 'center'
  },
  rowFLex: {
    display: 'flex',
    justifyContent: 'center',
    marginBottom: '2vh'
  },
  sortIcons: {
    marginLeft: '1vw',
    cursor: 'pointer'
  },
  midVertical: {
    display: 'table-cell',
    verticalAlign: 'middle'
  },
  noDocMessage: {
    textAlign: 'center',
    display: 'table',
    height: '80%',
    width: '100%'
  },
  images: {
    height: 'auto',
    width: '390px',
    maxHeight: '70vh'
  },
  previewHeader: {
    paddingBottom: '4vh',
    textAlign: 'center'
  },
  dashboardContainer: {
    height: '100%',
    backgroundColor: theme.palette.dark
  },
  processStatus: {
    color: 'white',
    fontSize: '15px',
    textAlign: 'center'
  },
  drawer: {
    [theme.breakpoints.up('sm')]: {
      width: '16%',
      flexShrink: 0,
    },
    backgroundColor: theme.palette.darkBlue
  },
  appBar: {
    [theme.breakpoints.up('sm')]: {
      width: `calc(100% - ${drawerWidth}px)`,
      marginLeft: '17%',
    },
    backgroundColor: theme.palette.blue
  },
  menuButton: {
    marginRight: theme.spacing(2),
    [theme.breakpoints.up('sm')]: {
      display: 'none',
    },
  },
  drawerPaper: {
    overflowY: 'hidden',
    border: 0,
    [theme.breakpoints.up('sm')]: {
      width: drawerWidth,
    },
    [theme.breakpoints.up('md')]: {
      width: '16%',
    },
    backgroundColor: theme.palette.darkBlue
  },
  content: {
    height: '100%',
    flexGrow: 1,
    [theme.breakpoints.up('sm')]: {
      paddingLeft: '16%',
    },
  },
  svg: {
    display: 'block',
    margin: 'auto',
    marginBottom: '3vh',
    marginTop: '5vh',
  },
  sideBarItems: {
    fontSize: '16px',
    color: theme.palette.coolGray,
    padding: '0px'
  },
  sideBarIcons: {
    marginLeft: '1vw',
    marginRight: '1vw',
    marginTop: '1vh',
    marginBottom: '1vh',
    cursor: 'pointer'
  },
  docIcons: {
    //marginLeft: '2vw',
    marginRight: '1vw',
    marginTop: '1vh',
    marginBottom: '1vh',
  },
  menuIcon: {
    color: theme.palette.white
  },
  sidebarFlex: {
    height: 'calc(100vh - 64px)',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    backgroundColor: theme.palette.darkBlue,
  },
  columnFlex: {
    display: 'flex',
    flexDirection: 'column'
  },
  button: {
    backgroundColor: theme.palette.blue,
    color: theme.palette.white,
    textTransform: 'unset',
    height: '48px',
    borderRadius: '6px',
    marginTop: '20px',
    fontSize: '16px'
  },

  importButton: {
    backgroundColor: theme.palette.blue,
    color: theme.palette.white,
    textTransform: 'unset',
    height: '44px',
    borderRadius: '6px',
    marginTop: '20px',
    fontSize: '16px',
    width: '168px'
  },
  sidebarFooter: {
    justifyContent: 'space-between',
    height: '27vh',
    margin: '0 auto',
    display: 'flex',
    flexDirection: 'column'
  },
  tableHeader: {
    color: theme.palette.steelGray,
    fontSize: '13px',
    paddingLeft: '0vw',
    fontWeight: 500,
    paddingRight: '0vw',
    borderColor: 'rgba(149,168,210, 0.12)',

  },
  tableData: {
    fontSize: '13px',
    padding: '1vh',
    paddingLeft: '0px',
    color: theme.palette.white,
    borderColor: 'rgba(149,168,210, 0.12)',
  },
  inactiveTableData: {
    fontSize: '13px',
    padding: '1vh !important',
    paddingLeft: '0px !important',
    color: theme.palette.battleShipGray,
    borderColor: 'rgba(149,168,210, 0.12)',
    pointerEvents: 'none'
  },
  templateNotFound: {
    fontSize: '13px',
    padding: '1vh !important',
    paddingLeft: '0px !important',
    borderColor: 'rgba(149,168,210, 0.12)',
    cursor: 'pointer',
    color: theme.palette.red,
    textDecoration: 'underline'
  },
  tableRow: {
    /*'&:hover': {
      backgroundImage: `linear-gradient(-90deg, ${theme.palette.blue}, ${theme.palette.dark})`,
      '& $tableData': {
        '& $modified': {
          visibility: 'hidden'
        },
        '& $options': {
          display: 'flex'
        }
      }

    }*/
  },
  options: {
    display: 'none',
    marginLeft: '3vw',
    marginTop: '-3vh'
  },
  optionIcons: {
    cursor: 'pointer',
  },
  modified: {
  },
  searchInput: {
    fontSize: '15px',
    height: '50px',
    boxSizing: 'border-box',
    padding: '0px !important'
  },
  docHeader: {
    fontSize: '28px',
    fontWeight: 300,
    color: theme.palette.coolGray,
    paddingLeft: '1.5vw',
  },
  headerContainer: {
    paddingTop: '4vh',
    display: 'flex',
    justifyContent: 'space-between',
    paddingRight: '2vw'
  },
  table: {
    maxWidth: '99%',
    backgroundColor: theme.palette.dark,
  },
  docTable: {
    maxWidth: '85vw',
    backgroundColor: 'transparent',
    marginTop: '2vh'
  },
  outerLoader: {
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: '400px'
  },
  progress: {
    color: theme.palette.red,
  },
  moreIcon: {
    fill: theme.palette.darkGray
  },
  menuItems: {
    fontSize: '13px'
  },
  mediumText: {
    fontSize: '15px',
    color: theme.palette.white
  },
  smallText: {
    fontSize: '13px',
    color: theme.palette.coolGray
  },
  trademark: {
    marginTop: '2vh',
    marginBottom: '2vh',
    fontSize: '13px',
    color: theme.palette.coolGray
  },
  dialog: {
    minWidth: '23vw',
    backgroundColor: 'transparent',
    width: '55vw',
    maxHeight: '100vh',
    boxShadow: 'none'
  },
  previewImage: {
    height: '82vh',
    width: '31vw'
  },
  uploadDialog: {
    minWidth: '23vw',
    height: '20vh',
  },
  zoomContainer: {
    height: '120px',
    width: '46px',
    opacity: '0.6',
    backgroundColor: theme.palette.charcoalGray,
    borderRadius: '8px'
  },
  loading: {
    top: '40%',
    right: '45%',
    position: 'fixed'
  },
  loaderDiv: {
    backgroundColor: theme.palette.dark,
    height: '100%'
  },

  backdrop: {
    backdropFilter: 'blur(10px)'
  },
  fileDialog: {
    minWidth: '45vw',
    minHeight: '35vh',
    backgroundColor: 'transparent',
    boxShadow: 'none'
  },
  icon: {
    color: 'white'
  },
  inputRoot: {
    paddingTop: '1px !important',
    paddingRight: '1px !important',
  }
});
